<template>
	<div>
		<topTab ref="topTab" :tabData='tabData' @tabChange='changePages'>
			<div class="usercym">
				<div class="user_left">
					<leftTree @nodeClick="nodeClick" @radioChange="radioChange"></leftTree>
				</div>
				<div class="user_right">
					<el-form :inline="true" :model="formInline" class="user-search" @submit.native.prevent>
						<el-form-item label="姓名/工号：">
							<el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.nameOrWorkNo"
								placeholder="请输入姓名/工号">
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">
								搜索
							</el-button>
							<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
							<el-button size="small" plain icon="el-icon-search" @click="handleFilter()">高级筛选</el-button>
						</el-form-item>
						<el-form-item style="float: right;margin-right: 0;">
							<el-button size="small" type="primary" class="el-icon-plus" @click="handleEdit()">新增
							</el-button>
							<el-button size="small" plain icon="el-icon-upload" @click="handleExport">导入</el-button>
							<el-button size="small" plain icon="el-icon-download" @click="clickExport">导出</el-button>
							<el-button size="small" plain icon="el-icon-upload"
								@click="clickBatchImport(1)">批量照片</el-button>
							<el-button size="small" plain icon="el-icon-upload"
								@click="clickBatchImport(2)">批量签名</el-button>
							<my-column-filter :listColumns="listColumns" @hidePop="getCheckBox"></my-column-filter>
						</el-form-item>
					</el-form>
					<!--列表-->
					<STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading"
						@handle-command="handleCommand" @rowDBClick="handleRowClick" :rowKey="'keyId'">
						<el-table-column align="center" slot="gender" label="性别" min-width="120">
							<template slot-scope="scope">
								<span v-if="scope.row.gender == 1" class="one_1">
									{{ formatterFre(scope.row.gender) }}</span>
								<span v-if="scope.row.gender == 0" class="one_2">
									{{ formatterFre(scope.row.gender) }}</span>
							</template>
						</el-table-column>
						<el-table-column align="center" slot="isActive" label="启用/停用" min-width="100">
							<template slot-scope="scope">
								<span @click.stop>
									<el-switch v-model="scope.row.isActive" active-color="#13ce66" inactive-color=""
										@change="editType(scope.row)">
									</el-switch>
								</span>
							</template>
						</el-table-column>
						<el-table-column slot="photoImg" label="照片" min-width="" align="center">
							<template slot-scope="scope">
								<div class="pic_bg" @click.stop>
									<img class="pic" v-if='scope.row.photoImg'
										:src="'data:image/jpeg;base64,' + scope.row.photoImg" alt=""
										@click="imgBig(scope.row.photoImg)">
									<span v-else>--</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column slot="signImg" label="签名" min-width="" align="center">
							<template slot-scope="scope">
								<div class="pic_bg" @click.stop>
									<img class="pic" v-if='scope.row.signImg'
										:src="'data:image/jpeg;base64,' + scope.row.signImg" alt=""
										@click="imgBig(scope.row.signImg)">
									<span v-else>--</span>
								</div>
							</template>
						</el-table-column>
					</STable>
					<!-- 分页组件 -->
					<Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
				</div>

			</div>

			<!-- 导入模板 -->
			<my-dialog dialogType="form" title="人员导入" :visible.sync="importWin" @click="closeImportWin"
				:close-on-click-modal="false">
				<div>
					导入模板 <span class="down_btn" @click="downTemplate">点击下载</span><br />
				</div>
				<el-upload style="margin-top: 10px;" class="upload-demo" :headers="myHeaders" :action="uploadUrl"
					:show-file-list="false" accept=".xlsx, .xls" :on-success="progress" :on-progress="onLoading"
					:auto-upload="true">
					<el-button size="small" style="background: #13CE66;color: #FFFFFF;" class="el-icon-printer" label=""
						perms="opInsert">选取文件</el-button>
				</el-upload>
				<div class="redTip">
					<div class="fontWight600">Tips</div>
					1、下载模板</br>
					2、模板中的列标题名文字不能修改，顺序不能修改，不能添加或者删除列。</br>
					3、导入的数据中间不能有空行。</br>
					4、不能合并单元格。</br>
				</div>
				<div>
					<el-table :data="tableData" style="width: 100%" border
						:header-cell-style="{ background: '#e5e5e5', color: '#000000', height: '3.125rem' }">
						<el-table-column prop="xh" label="序号" width="200px">
						</el-table-column>
						<el-table-column prop="rybh" label="人员编号" width="200px">
							<template slot-scope="scope">
								<div>
									<div class="table_div">1、人员编号或者称员工号。</div>
									<div class="table_div">2、不能为空。</div>
									<div class="table_div">3、系统中已存在的不允许重复导入。</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="姓名" width="200px">
						</el-table-column>
						<el-table-column prop="kh" label="卡号">
						</el-table-column>
						<el-table-column prop="rylb" label="人员类别" width="200px">
							<template slot-scope="scope">
								<div>
									<div class="table_div">1、人员类别不能为空。</div>
									<div class="table_div">
										2、人员类别的中文需要在系统中的数据字典中的人员类别子集中。</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="xb" label="性别" width="200px">
							<template slot-scope="scope">
								<div>
									<div class="table_div">1、性别不能为空且需要包含【男】或者【女】!</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="dept" label="部门" width="200px">
							<template slot-scope="scope">
								<div>
									<div class="table_div">1、部门不能为空。</div>
									<div class="table_div">
										2、部门内容需要为从顶级到所在级别，中间使用英文状态下的斜杠【/】分隔层级，如:焊接参数采集及质量系统单元/产品制造部/计划调度室/配套调度计划组。</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="gw" label="岗位">
						</el-table-column>
						<el-table-column prop="remark" label="备注">
						</el-table-column>
					</el-table>
				</div>
			</my-dialog>
			<!-- 图片放大 -->
			<my-dialog dialogType="form" title="图片查看" :visible.sync="imgBigShow" width="36rem"
				:close-on-click-modal="false">
				<img :src="'data:image/jpeg;base64,' + PhtotPath" class="imgBig" />
			</my-dialog>
		</topTab>
		<!-- 新增/编辑界面 -->
		<edit ref="edit" :deptData="deptData" :roleData="roleData"></edit>
		<!-- 上传图片界面 -->
		<upImg ref="upImg"></upImg>
		<!-- 批量上传照片/签名 -->
		<importPic ref="importPic"></importPic>
		<filterMore ref="filterMore" @filterMoreCallBack="filterMoreCallBack"></filterMore>
	</div>

</template>

<script>
import {
	GetUserListForPage,
	DeleteUserInfo,
	SaveUserInfo,
	GetRoleDropList,
	GetUserInfoExport,
	ResetPwd
} from '../../../api/userApi.js'
import {
	GetOrganizationTreeList,
} from '../../../api/organizationalApi.js'
import {
	GetDicDataListByParentCode
} from '../../../api/dicDataApi.js';
import edit from './edit';
import upImg from './upImg'
import importPic from './importPic'
import leftTree from './leftTree'
export default {
	// 注册组件
	components: {
		edit,
		upImg,
		importPic,
		leftTree
	},
	data() {
		return {
			activeTab: '1',
			tabData: [{
				key: '1',
				value: '人员列表'
			}],
			roleData: [],
			deptData: [],
			pageShow: true,
			loading: false,
			dataState: [{
				code: true,
				text: '启用'
			},
			{
				code: false,
				text: '停用'
			},
			],
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				searchKey: '',
				nameOrWorkNo: '',
				deptCode: "",
				roleId: "",
			},
			listData: [], //数据
			// 分页参数
			pageparm: {
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			imgBigShow: false,
			PhtotPath: "",
			columnsData: [], //显示列
			listColumns: [{
				prop: 'rowNumber',
				label: '序号',
				align: 'center',
				fixed: 'left',
				width: '60',
				isKeep: true
			},
			{
				prop: 'chName',
				isKeep: true,
				label: '姓名'
			},
			{
				prop: 'userName',
				label: '用户名'
			},
			{
				slot: 'gender',
				label: '性别'
			},
			{
				prop: 'workerNo',
				label: '工号'
			},
			{
				prop: 'cardNo',
				label: '卡号'
			},
			{
				prop: 'roleName',
				label: '角色'
			},
			{
				prop: 'phone',
				label: '联系方式'
			},
			{
				slot: 'isActive',
				label: '启用/停用'
			},
			{
				slot: 'photoImg',
				label: '照片'
			},
			{
				slot: 'signImg',
				label: '签名'
			},
			{
				operation: true,
				isKeep: true,
				label: '操作',
				btnGroup: [{
					icon: "el-icon-picture-outline",
					name: "照片",
					type: "3",
				},
				{
					icon: "el-icon-camera",
					name: "签名",
					type: "4"
				},
				{
					icon: "el-icon-delete",
					name: "删除",
					type: "5",
					btnType: 'danger'
				},
				{
					icon: "el-icon-refresh-right",
					name: "重置密码",
					type: "6"
				},
				],
			},
			],
			importWin: false,
			myHeaders: {
				Authorization: 'Bearer ' + localStorage.getItem('logintoken'),
			},
			uploadUrl: '/api/sysConfig/User/ImportUserInfoExcel',
			tableData: [{
				xh: '1、序号不能为空!',
				rybh: '1、人员编号或者称员工号。2、 不能为空。3、 系统中已存在的不允许重复导入。',
				name: '1、姓名不能为空。',
				kh: '',
				rylb: '1、人员类别不能为空。2、人员类别的中文需要在系统中的数据字典中的人员类别子集中。',
				xb: '1、性别不能为空且需要包含【男】或者【女】!',
				dept: '1、部门不能为空。2、部门内容需要为从顶级到所在级别，中间使用英文状态下的斜杠【/】分隔层级，如:焊接参数采集及质量系统单元/产品制造部/计划调度室/配套调度计划组',
				gw: '',
				remark: '',
			}],
			userTypeList: []
		}
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map(item => item.label))
		this.getListData();
		this.getDeptData();
		this.getRoleData();
		this.getUserType()
	},

	methods: {
		handleFilter() {
			let initForm = {
				initSearch: {
					pageIndex: 1,
					pageSize: 10,
				},
				formList: [{
					label: '姓名/卡号',
					prop: 'nameOrCard',
					input: true,
				},
				{
					label: '人员职级',
					prop: 'userRank',
					input: true,
				},
				{
					label: '人员类别',
					prop: 'userType',
					select: true,
					modelValue: 'dicCode',
					modelLabel: 'dicText',
					options: this.userTypeList
				},
				{
					label: '角色',
					prop: 'roleId',
					select: true,
					modelValue: 'keyId',
					modelLabel: 'value',
					options: this.roleData
				},
				{
					label: '所属部门',
					prop: 'deptCode',
					cascader: true,
					cascaderProps: {
						label: 'name',
						value: 'keyId',
						children: 'subList',
						checkStrictly: true,
						expandTrigger: 'click',
					},
					options: this.deptData
				},
				]
			}
			this.$refs.filterMore.filterShow(this.formInline, initForm)
		},
		filterMoreCallBack(params) {
			this.formInline = params
			this.search()
		},
		// 获取人员类型
		getUserType() {
			let parmter = {
				parentCode: "UserType",
			};
			GetDicDataListByParentCode(parmter)
				.then((res) => {
					if (res.code == 1) {
						this.userTypeList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("加载失败，请稍后再试！");
				});
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter(v => !val.includes(v.label))
			this.columnsData = this.listColumns.filter(i => !arr.includes(i));
		},
		changePages() { },
		handleCommand(command) {
			switch (command.command) {
				case '3':
					this.uploadImage(command.rowData, false);
					break;
				case '4':
					this.uploadImage(command.rowData, true);
					break;
				case '5':
					this.deleteData(command.rowData);
					break;
				case '6':
					this.resetPwd(command.rowData);
					break;
				default:
					console.log(command)
			}
		},

		// 导入
		handleExport() {
			this.importWin = true;
		},

		// 下载模板
		downTemplate() {
			let fullDownloadUrl = '/api/sysConfig/DownLoad/DownLoadUserImportTemp'
			let fileInfoName = '人员导入模板.xlsx';
			this.$preloadWeb.fileDownLoad({
				fullDownloadUrl,
				fileInfoName,
			});
		},

		// 左侧radio切换
		radioChange() {
			this.formInline.pageIndex = 1
			this.pageShow = false
			this.$nextTick(() => {
				this.pageShow = true
			})
			this.formInline.roleId = '';
			this.formInline.deptCode = '';
			this.getListData();
		},

		// 左侧树节点点击
		nodeClick(node, type) {
			this.formInline.pageIndex = 1
			this.pageShow = false
			this.$nextTick(() => {
				this.pageShow = true
			})
			if (type === 1) {
				this.formInline.roleId = '';
				this.formInline.deptCode = node.keyId;
			} else {
				this.formInline.deptCode = '';
				this.formInline.roleId = node.keyId;
			}
			this.getListData();
		},

		handleChange(value) {
			if (value) {
				this.formInline.deptCode = value[value.length - 1]
				this.getListData()
			}
		},
		imgBig(PhtotPath) {
			this.imgBigShow = true;
			this.PhtotPath = PhtotPath;
		},
		// 性别
		formatterFre(gender) {
			return gender == 1 ? "男" : gender == 0 ? "女" : "";
		},

		// 单击行数据
		handleRowClick(row) {
			this.$refs.edit.editShow(row);
		},


		//显示编辑界面
		handleEdit(row) {
			this.$refs.edit.editShow(row)
		},

		// 上传签名/照片
		uploadImage(row, name) {
			this.$refs.upImg.upImgGo(row, name)
		},

		// 批量导入照片/签名
		clickBatchImport(type) {
			this.$refs.importPic.uploadImage(type)
		},

		// 点击导出
		clickExport() {
			this.getUserInfoExport();
		},

		// 人员导出
		getUserInfoExport() {
			const that = this;
			GetUserInfoExport(this.formInline)
				.then((res) => {
					if (res.code == 1 && res.data === true) {
						let fullDownloadUrl = '/api/sysConfig/DownLoad/DownLoadFile?fileName=' +
							encodeURIComponent(res.msg)
						let temp = res.msg.split("/");
						let fileInfoName = temp.pop();
						this.$preloadWeb.fileDownLoad({
							fullDownloadUrl,
							fileInfoName,
						});

					} else {
						this.$message({
							type: 'info',
							message: res.msg,
						});
					}
				})
				.catch((err) => {
					this.$message.error('数据加载失败，请稍后再试！');
				});
		},

		// 导入成功回调
		progress(event, file) {
			if (event.code == 1) {
				if (event.data == true) {
					this.$message.success('导入成功');
					this.getListData();
					this.importWin = false;
				} else {
					let url = event.msg;
					// this.$message.warning('存在导入失败的数据，正在下载');
					// this.importWin = false;
					let fullDownloadUrl = '/api/sysConfig/DownLoad/DownLoadFile?fileName=' +
						encodeURIComponent(url)
					let temp = url.split("/");
					let fileInfoName = temp.pop();
					this.$preloadWeb.fileDownLoad({
						fullDownloadUrl,
						fileInfoName,
					});
				}
			} else {
				this.$message({
					type: 'error',
					message: event.msg,
				});
			}
		},
		// 文件正在导入
		onLoading(event, file) {
			const load = this.$loading({
				lock: true,
				text: '正在导入数据...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.4)',
			});
			if (event.code == 0) {
				load.close();
				this.$message({
					type: 'info',
					message: event.msg,
				});
			} else {
				load.close();
			}
		},
		closeImportWin() {
			this.importWin = false;
		},


		// 删除
		deleteData(row) {
			let parameter = {
				keyId: row.keyId,
			}
			this.$confirm('是否删除<' + row.chName + '>?', '信息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					DeleteUserInfo(parameter)
						.then(res => {
							if (res.code === 1) {
								this.$message({
									type: 'success',
									message: '已删除!'
								})
								this.getListData(this.formInline)
							} else {
								this.$message({
									type: 'info',
									message: res.msg
								})
							}
						})
						.catch(err => {
							this.loading = false
							this.$message.error('删除失败，请稍后再试！')
						})
				})
		},

		// 修改是否显示
		editType(row) {
			SaveUserInfo(row).then(res => {
				this.loading = true
				if (res.code == 1) {
					this.$message({
						type: 'success',
						message: '修改成功'
					})
					setTimeout(() => {
						this.getListData()
					}, 500);
				} else {
					this.$message({
						type: 'info',
						message: res.msg
					})
					this.loading = false
				}
			}).catch((err) => {
				this.$message.error('加载失败，请稍后再试！');
			});
		},
		//获取部门下拉
		getDeptData() {
			let param = {
				parentId: ''
			}
			GetOrganizationTreeList(param)
				.then((res) => {
					if (res.code == 1) {
						this.deptData = this.recursion(res.data)
					} else {
						this.$message.error(res.msg);
					}
				}).catch((err) => {
					this.$message.error('加载失败，请稍后再试！');
				});
		},
		// 递归删除空子节点（数据字典）
		recursion(data) {
			data.forEach(item => {
				if (item.subList && item.subList.length > 0) {
					return this.recursion(item.subList)
				} else {
					delete item.subList
				}
			})
			return data
		},
		//获取角色下拉
		getRoleData() {
			GetRoleDropList()
				.then((res) => {
					if (res.code == 1) {
						this.roleData = res.data;
					} else {
						this.$message.error(res.msg);
					}
				}).catch((err) => {
					this.$message.error('加载失败，请稍后再试！');
				});
		},
		inputChange() {
			this.search()
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1
			this.pageShow = false
			this.$nextTick(() => {
				this.pageShow = true
			})
			this.getListData(this.formInline)
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline
			this.search();
		},
		// 获取列表
		getListData() {
			this.loading = true
			GetUserListForPage(this.formInline)
				.then(res => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message.error(res.msg)
						this.loading = false;
					}
				})
				.catch(err => {
					this.loading = false
					this.$message.error('列表加载失败，请稍后再试！')
				})
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData(this.formInline);
		},
		// 重置密码
		resetPwd(row) {
			this.$confirm('是否重置密码?', '信息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let params = {
					keyId: row.keyId
				};
				ResetPwd(params).then(res => {
					this.loading = true
					if (res.code == 1) {
						this.$message({
							type: 'success',
							message: '重置成功'
						})
						setTimeout(() => {
							this.getListData()
						}, 500);
					} else {
						this.$message({
							type: 'info',
							message: res.msg
						})
						this.loading = false
					}
				}).catch((err) => {
					this.$message.error('加载失败，请稍后再试！');
				});
			})
		},
	}
}
</script>
<style scoped>
::deep .el-table th>.cell {
	color: #333;
}

::deep .btnList .el-button--mini,
.el-button--mini.is-round {
	padding: 9px 16px !important;
}

.upload-demo {
	display: inline;
	margin-left: 8px;
	margin-right: 8px
}

.dowm_box {
	padding-top: 10px;
	font-weight: 600;
	font-size: 14px;
}

.pic_bg {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.pic {
	width: 30px;
	height: 30px;
}

.pic:hover {
	cursor: pointer;
}

.hover_:hover {
	cursor: pointer;
}

.imgBig {
	width: 100%;
}

.usercym {
	/* width: 100%; */
	height: 100%;
	/* background: #fff; */
	display: flex;
	/* margin-top: 15px; */
	/* margin-bottom: 15px; */
	border-radius: 10px;
}

.user_left {
	width: 16%;
	background-color: #fff;
	margin-top: 15px;
	max-height: 46.2rem;
	overflow-y: auto;
	border-radius: 10px;
	border-right: 1px solid #eeeeee;
}

.user_right {
	width: 84%;
	height: calc(100vh - 3.5rem);
	max-height: 46.2rem;
	padding-left: 20px;
}

.one_1 {
	padding: 2px 20px;
	background: #E6F7FF;
	border: 1px solid #6acaf3;
	color: #56bbfd;
	border-radius: 2px;
}

.one_2 {
	padding: 2px 20px;
	background: #fcd4ff;
	border: 1px solid #dfbce2;
	color: #ea7cff;
	border-radius: 2px;
}

::deep .el-switch__core {
	width: 40px !important;
}

.down_btn {
	color: #5555ff;
	cursor: pointer;
}

.table_div {
	width: 200px;
	height: 20px;
	line-height: 20px;
	display: table;
}

.redTip {
	color: red;
	font-size: 10px;
	padding: 10px 10px;
}

.fontWight600 {
	font-weight: 600;
	font-size: 14px;
	padding-bottom: 3px;
}
</style>